import url from './url';



export default url(() => '/categories/create');
